import firebase from 'firebase/app';
import 'firebase/firestore';

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: 'AIzaSyARIZmxPsNEf_rxsyNqqDpchhGzo26Aog8',
  authDomain: 'test-quiz-10e7a.firebaseapp.com',
  databaseURL: 'https://test-quiz-10e7a.firebaseio.com',
  projectId: 'test-quiz-10e7a',
  storageBucket: 'test-quiz-10e7a.appspot.com',
  messagingSenderId: '82381329593',
  appId: '1:82381329593:web:395047fbe428aecfc1f768',
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const fire = firebase.firestore();

export default fire;
